import { productCategoryData } from './OnboardingDataSelect'
export const professionalServicesCategoryTest = (
  categories: any[] | undefined
) => {
  categories = categories ?? []
  const professionalLabels = productCategoryData
    .filter(product => product.group === 'Professional Services')
    .map(product => product.label)
  return categories.some(category => professionalLabels.includes(category))
}
